import { TemplateControlType } from 'src/app/modules/management/store/communication-center';
import { SettingsWrapperControl } from './settings-wrapper-control';
import { DesignControl } from './design-control';
import { TemplateControlService } from './template-control.service';

const displayControlTemplate = `
<div>
  <div
    style="
      font-size: 18px;
      font-family: Verdana, Geneva, Tahoma, sans-serif;
      font-weight: 700;
      color: #6e6986;
      margin-top: 8px;
      display: block;
    "
    class="run-time"
  >
    Section Header
  </div>
</div>`;

const settingsControlTemplate = `
<div style="position:relative;margin: 4px 0px 4px 2px;">
  <input type="text" style="
    background-color: var(--neutral-color-000);
    border: none;
    color: #6e6986;
    font-size: 18px;
    font-weight: 700;
    max-width: calc(100% - 20px);
    outline: none;
    width: calc(100% - 20px);" />
</div>`;

export class SectionHeaderControl extends DesignControl {
  editSettingsControl: HTMLElement;
  settingsWrapperControl: SettingsWrapperControl;

  constructor(document: Document, templateControlService: TemplateControlService) {
    super(document, templateControlService);

    this.controlTemplate = displayControlTemplate;
    this.settingsTemplate = settingsControlTemplate;
    this.controlType = TemplateControlType.SectionHeader;
    this.settingsWrapperControl = this.templateControlService.settingsWrapperControl;
  }

  public edit(): void {
    const sectionHeaderValue = this.controlElement.firstElementChild.textContent.trim();

    this.editSettingsControl = this.document.createElement('div');
    this.editSettingsControl.innerHTML = this.settingsTemplate;

    this.settingsWrapperControl.setContent(this.editSettingsControl);

    const input = this.editSettingsControl.getElementsByTagName('input')[0];
    input.value = sectionHeaderValue;
    input.focus();
  }

  public cancel(): void {
    this.settingsWrapperControl.clearContent();
    this.editSettingsControl = null;
  }

  public save(): void {
    const input = this.editSettingsControl.getElementsByTagName('input')[0];
    this.controlElement.firstElementChild.textContent = input.value;

    this.settingsWrapperControl.clearContent();
    this.editSettingsControl = null;
  }

  public copy(): void {}
}
